/**
 * Pre-hydration fallback for the `legislationInForceOnly` filter default.
 *
 * SOURCE OF TRUTH: `DEFAULT_LEGISLATION_IN_FORCE_ONLY` in
 * `backend/packages/lexomat-backend/src/lexomat_backend/server/research/search/types.py`
 * (#7623). It is served in the `GET /filters/defaults` payload
 * (`FilterDefaultsResponse.legislation.legislationInForceOnly`) and read into
 * Redux as `state.filterDataReducer.defaultSpecialFilters.legislationInForceOnly`
 * by `initializeFiltersAndApplyDefaults` in `lib/redux/slices/filters.ts`.
 *
 * This constant exists ONLY for the narrow window before that fetch resolves —
 * initial Redux state has `legislation.legislationInForceOnly: undefined` — where
 * a selector or request-serializer needs a value synchronously (e.g. a search
 * fired before the defaults call completes). Once the API value is available it
 * always wins; this fallback is never allowed to override it.
 *
 * Must stay in sync with the backend constant. If the backend default ever
 * changes, update this too (#7652). `legislationInForceOnlyDefaults.test.ts`
 * fences against reintroducing scattered literals instead of importing this.
 */
export const PRE_HYDRATION_LEGISLATION_IN_FORCE_ONLY_DEFAULT = true;
